import * as _postcssSelectorParser2 from "postcss-selector-parser";
var _postcssSelectorParser = _postcssSelectorParser2;
try {
  if ("default" in _postcssSelectorParser2) _postcssSelectorParser = _postcssSelectorParser2.default;
} catch (e) {}
import { dew as _pseudoElements2Dew } from "./pseudoElements";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  Object.defineProperty(exports, "applyImportantSelector", {
    enumerable: true,
    get: function () {
      return applyImportantSelector;
    }
  });
  const _postcssselectorparser = /*#__PURE__*/_interop_require_default(_postcssSelectorParser);
  const _pseudoElements = _pseudoElements2Dew();
  function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function applyImportantSelector(selector, important) {
    let sel = (0, _postcssselectorparser.default)().astSync(selector);
    sel.each(sel => {
      // Wrap with :is if it's not already wrapped
      let isWrapped = sel.nodes[0].type === "pseudo" && sel.nodes[0].value === ":is" && sel.nodes.every(node => node.type !== "combinator");
      if (!isWrapped) {
        sel.nodes = [_postcssselectorparser.default.pseudo({
          value: ":is",
          nodes: [sel.clone()]
        })];
      }
      (0, _pseudoElements.movePseudos)(sel);
    });
    return `${important} ${sel.toString()}`;
  }
  return exports;
}